const CART_DRAWER_ID = 'cart-drawer';
const desktopDrawerQuery = window.matchMedia('(min-width: 990px)');

/**
 * Removes a stale cart-drawer restore entry left by Horizon's desktop
 * sidebar mode. The WellHome cart is intentionally transient and modal.
 */
function clearPersistedCartDrawer() {
  try {
    const ids = (sessionStorage.getItem('theme-drawer-open') || '')
      .split(',')
      .filter(Boolean)
      .filter((id) => id !== CART_DRAWER_ID);

    if (ids.length) {
      sessionStorage.setItem('theme-drawer-open', ids.join(','));
    } else {
      sessionStorage.removeItem('theme-drawer-open');
    }
  } catch (error) {
    console.warn('[WellHome header] Drawer state could not be cleared.', error);
  }
}

function ensureCartOverlay() {
  const drawer = document.getElementById(CART_DRAWER_ID);
  if (!(drawer instanceof HTMLElement)) return;

  drawer.setAttribute('no-persist', '');

  const panel = drawer.querySelector('dialog');
  if (!(panel instanceof HTMLDialogElement)) return;
  if (!drawer.hasAttribute('open') || !panel.open) return;

  let isModal = false;
  try {
    isModal = panel.matches(':modal');
  } catch (_error) {
    isModal = false;
  }

  if (isModal) return;

  const focusTarget = panel.contains(document.activeElement) && document.activeElement instanceof HTMLElement
    ? document.activeElement
    : null;

  panel.close();
  document.documentElement.setAttribute('scroll-lock', '');
  panel.showModal();

  requestAnimationFrame(() => {
    if (focusTarget && document.contains(focusTarget)) {
      focusTarget.focus();
    } else {
      panel.querySelector('.theme-drawer__close-button')?.focus();
    }
  });
}

function createAnnouncementSet(text) {
  const set = document.createElement('span');
  set.className = 'wh-announcement-marquee__set';

  for (let index = 0; index < 4; index += 1) {
    const item = document.createElement('span');
    item.className = 'wh-announcement-marquee__item';
    item.textContent = text;

    const separator = document.createElement('i');
    separator.className = 'wh-announcement-marquee__separator';
    separator.textContent = '·';

    set.append(item, separator);
  }

  return set;
}

function initialiseAnnouncementMarquee(root = document) {
  const slides = root.querySelectorAll('.announcement-bar .announcement-bar__slide');

  for (const slide of slides) {
    if (!(slide instanceof HTMLElement)) continue;

    const announcementBar = slide.closest('.announcement-bar');
    const accessibleText = slide.querySelector('.announcement-bar__text');
    if (!(announcementBar instanceof HTMLElement) || !(accessibleText instanceof HTMLElement)) continue;

    const slideCount = announcementBar.querySelectorAll('.announcement-bar__slide').length;
    const configuredText = announcementBar.dataset.announcementText?.trim();

    if (slideCount === 1 && configuredText) {
      accessibleText.textContent = configuredText;
    }

    const text = accessibleText.textContent?.trim();
    const existingTrack = slide.querySelector(':scope > .wh-announcement-marquee__track');

    if (!announcementBar.classList.contains('announcement-bar--mobile-marquee') || !text) {
      existingTrack?.remove();
      accessibleText.classList.remove('wh-announcement-marquee__accessible');
      delete slide.dataset.whMarqueeReady;
      continue;
    }

    if (existingTrack instanceof HTMLElement && existingTrack.dataset.sourceText === text) {
      accessibleText.classList.add('wh-announcement-marquee__accessible');
      slide.dataset.whMarqueeReady = 'true';
      continue;
    }

    existingTrack?.remove();
    accessibleText.classList.add('wh-announcement-marquee__accessible');

    const track = document.createElement('span');
    track.className = 'wh-announcement-marquee__track';
    track.dataset.sourceText = text;
    track.setAttribute('aria-hidden', 'true');
    track.append(createAnnouncementSet(text), createAnnouncementSet(text));

    slide.append(track);
    slide.dataset.whMarqueeReady = 'true';
  }
}

clearPersistedCartDrawer();
initialiseAnnouncementMarquee();
ensureCartOverlay();

document.addEventListener('theme-drawer:open', (event) => {
  if (!(event.target instanceof Element) || event.target.id !== CART_DRAWER_ID) return;
  ensureCartOverlay();
});

desktopDrawerQuery.addEventListener('change', () => {
  requestAnimationFrame(ensureCartOverlay);
});

window.addEventListener('pageshow', ensureCartOverlay);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initialiseAnnouncementMarquee(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  if (event.target instanceof Element) initialiseAnnouncementMarquee(event.target.closest('.shopify-section') || event.target);
});
